<template>
    <div>
        <div id="contacts"></div>
        <v-container fluid class="screen">
            <v-layout row wrap>
                <v-flex xs12 class="text-xs-center">
                    <h1>Наши контакты</h1>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 class="text-xs-center mt-3">
                    <div class="contacts-box">Адрес: г. Новокузнецк, Орджоникидзе, 13 </div>
                    <div class="contacts-box">Работаем круглосуточно без выходных!</div>
                    <div class="contacts-box"
                    >Тел.:
                        <a
                                href="tel:+79617065757"
                                onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
                        >8 (961) 706-57-57
                        </a>
                    </div>
                    <div class="contacts-box"
                    >Тел.:
                        <a
                                href="tel:+73843200016"
                                onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
                        >8 (3843) 200-016
                        </a>
                    </div>
                    <div class="contacts-box"
                    >Кафе - тел.:
                        <a
                                href="tel:+79059158830"
                                onclick="yaCounter50723809.reachGoal('call_ok'); return true;"
                        >8 (905) 915-88-30
                        </a>
                    </div>
                    <div class="contacts-box">E-mail: <a class="contacts-link" href="mailto:malinasadkoveles@gmail.com">malinasadkoveles@gmail.com</a></div>
                    <a href="https://instagram.com/sauna_akropol_nvkz" target="_blank"
                    ><font-awesome-icon class="contacts-social instagram" :icon="['fab', 'instagram']"></font-awesome-icon></a>
                </v-flex>
            </v-layout>
        </v-container>

        <div @click="mapScroll">
            <iframe
                    :style="'pointer-events: '+pointerEvents+';'"
                    src="https://yandex.ru/map-widget/v1/?um=constructor%3Ace99f016b4be2fef1ccccea74b14d2960f2e454835f4e786b4fa7af7fa1afc3e&amp;source=constructor"
                    width="100%"
                    height="400px"
                    frameborder="0"
            ></iframe>
        </div>

    </div>
</template>

<script>
export default {
  data () {
    return {
      pointerEvents: 'none'
    }
  },
  methods: {
    mapScroll () {
      if (this.pointerEvents === 'none') {
        this.pointerEvents = 'all'
        return this.pointerEvents
      }
      if (this.pointerEvents === 'all') {
        this.pointerEvents = 'none'
        return this.pointerEvents
      }
    }
  }
}
</script>

<style scoped>
    #contacts {
        position: relative;
        top: -30px;
    }

    a,
    a:hover
    a:visited
    a:active {
        color: green;
        text-decoration: none;
    }

    .contacts-box {
        margin: 10px 0;
    }

    .contacts-link {
        padding-bottom: 1px;
        border-bottom: 1px dotted green;
    }

    .contacts-link:hover {
        border-bottom: none;
    }

    .contacts-social {
        margin-top: 30px;
        width: 70px;
        height: 70px;
    }

    .instagram {
        color: rgba(76, 104, 215, 1.0);
    }

    .instagram:hover {
        color: rgba(76, 104, 215, .8);
    }

    /* MEDIA */
    /* EXTRA SMALL */
    @media (max-width: 600px) {

    }
</style>



// WEBPACK FOOTER //
// src/components/screens/acropolis/Contacts.vue